import React, { Dispatch, SetStateAction } from 'react'
import { Modal } from 'react-bootstrap'
import { useIntl } from 'react-intl'
import { BasicButton } from './UI/BasicButton'

export const GeneralConfirmationModal = ({
  showGeneralModal,
  setGeneralShowModal,
  headingMessage,
  description,
  handleConfirm,
  generalLoading,
  buttonText,
}: {
  showGeneralModal: boolean
  setGeneralShowModal: Dispatch<SetStateAction<boolean>>
  headingMessage: string
  description: string
  handleConfirm: any
  generalLoading: boolean
  buttonText: string
}) => {
  const { formatMessage } = useIntl()

  return (
    <Modal
      show={showGeneralModal}
      onHide={() => setGeneralShowModal(false)}
      aria-labelledby='contained-modal-title-vcenter'
      centered
    >
      <Modal.Header closeButton>
        <h2>{formatMessage({ id: headingMessage })}</h2>
      </Modal.Header>
      <Modal.Body>
        <p>
          {formatMessage({
            id: description,
          })}
        </p>
      </Modal.Body>
      <Modal.Footer>
        <div className='d-flex flex-md-row flex-column justify-content-md-end gap-2 w-100'>
          <BasicButton
            onClick={() => {
              setGeneralShowModal(false)
            }}
            buttonText='Cancel'
            customClass='w-md-auto w-100 custom-button-property bg-light text-muted order-2 order-md-1'
          />

          <BasicButton
            onClick={() => {
              handleConfirm()
            }}
            buttonText={buttonText}
            customClass='w-md-auto w-100 custom-button-property bg-primary text-white order-1 order-md-2'
            loading={generalLoading}
            disabled={generalLoading}
          />
        </div>
      </Modal.Footer>
    </Modal>
  )
}
